import styled from 'styled-components';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const Bg = styled('div')({
    backgroundColor: '#EDEDED',
    paddingLeft: '11%',
    paddingRight: '11%',
    paddingBottom: '6%',
    paddingTop: '6%',
    [MediaQuery[Size.XL]]: {
        paddingLeft: '7%',
        paddingRight: '7%',
    },
    [MediaQuery[Size.MD]]: {
        paddingLeft: '4%',
        paddingRight: '4%',
    }
});

export const Title = styled('div')({
    fontSize: "26px",
    fontWeight: "400",
    lineHeight: "26px",
    fontFamily: "Gotham",
    [MediaQuery[Size.SM]]: {
        fontSize: "20px",
    },
});

export const Button = styled('div')({
    fontSize: "14px",
    fontWeight: "400",
    marginTop: "12px",
    backgroundColor: "#CCA25E",
    borderRadius: "45px",
    [MediaQuery[Size.SM]]: {
        fontSize: "12px",
    },
});

export const ButtonText = styled('div')({
    backgroundColor: "#CCA25E",
    fontSize: "28px",
    fontWeight: "600",
    width: "425px",
    height: "70px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: "45px",
    marginTop: "12px",

    [MediaQuery[Size.NAV]]: {
        width: "90%",
        borderRadius: "24px",
        height: "50px",
    },

    [MediaQuery[Size.SM]]: {
        fontSize: "20px",
        borderRadius: "24px",
        height: "50px",
    },
});

export const FirstCard = styled('div')({
    width: "60%",
    marginRight: "1%",
});

export const MiniFirstImage = styled('img')({
    width: "36%",
    height: "auto",
});

export const FirstImage = styled('img')({
    width: "auto",
    height: "auto",
    margin: "auto",
    [MediaQuery[Size.LG]]: {
        width: "121px",
    },
    
    [MediaQuery[Size.MD]]: {
        width: "70%",
    },
    [MediaQuery[Size.SM]]: {
        width: "80%",
    },
});
